import NewOrderItemDisplayType from "@/scenes/OrderManagement/enum/NewOrderItemDisplayType";

// TODO: 等过段时间后可考虑直接移除旧数据
// 旧版数据key
const ORDER_ITEM_DISPLAY_KEY_V1 = "__ORDER_ITEM_DISPLAY_KEY__";
type OrderItemDisplayDataV1 = NewOrderItemDisplayType[];

// v2数据key
const ORDER_ITEM_DISPLAY_KEY = "__ORDER_ITEM_DISPLAY_KEY_V2__";
export type OrderItemDisplayData = Partial<Record<NewOrderItemDisplayType, boolean | undefined>>;

const defaultOrderItemDisplayData: OrderItemDisplayData = {
    [NewOrderItemDisplayType.PIC]: true,
    [NewOrderItemDisplayType.TITLE]: true,
    [NewOrderItemDisplayType.EXTERNAL_ID]: true,
    [NewOrderItemDisplayType.SKU_PROPERTIES]: true,
    [NewOrderItemDisplayType.GIFT]: true,
};

/**
 * 获取v1的缓存数据
 */
function getOrderItemDisplayTypesStorageV1() {
    const orderItemDisplayTypeStr = localStorage.getItem(ORDER_ITEM_DISPLAY_KEY_V1);

    if (orderItemDisplayTypeStr) {
        try {
            const orderItemDisplayType = JSON.parse(orderItemDisplayTypeStr);

            return orderItemDisplayType as OrderItemDisplayDataV1;
        } catch (error) {}
    }
}

/**
 * 获取v2的缓存数据
 */
function getOrderItemDisplayDataStorageV2() {
    const orderItemDisplayStr = localStorage.getItem(ORDER_ITEM_DISPLAY_KEY);

    if (orderItemDisplayStr) {
        try {
            const orderItemDisplay = JSON.parse(orderItemDisplayStr);

            return orderItemDisplay as OrderItemDisplayData;
        } catch (error) {}
    }
}

/**
 * 获取商品显示信息缓存数据
 *
 * 1.从第二版缓存中获取
 * 2.第二版获取不到再降级到v1
 * 3.最后还获取不到走默认数据
 */
export function getOrderItemDisplayDataStorage() {
    const data = getOrderItemDisplayDataStorageV2();

    if (data) {
        return data;
    }

    const types = getOrderItemDisplayTypesStorageV1();

    // 如果有旧数据，则执行迁移操作
    if (types) {
        const data: OrderItemDisplayData = {};

        for (let i = 0; i < types.length; i++) {
            const type = types[i];

            data[type] = true;
        }

        // 新类型迁移
        data[NewOrderItemDisplayType.GIFT] = true;

        saveOrderItemDisplayDataStorage(data);

        return data;
    }

    return defaultOrderItemDisplayData;
}

export function saveOrderItemDisplayDataStorage(orderItemDisplayData: OrderItemDisplayData) {
    const orderItemDisplayDataStr = JSON.stringify(orderItemDisplayData);

    localStorage.setItem(ORDER_ITEM_DISPLAY_KEY, orderItemDisplayDataStr);
}
